/**
 * @fileoverview Renders a filtered proposals list or an empty-state message.
 */
import Proposal from "./Proposal.jsx";

const EMPTY_MESSAGE_KEYS = {
  pending: "components.proposalsListModal.noPendingProposals",
  accepted: "components.proposalsListModal.noAcceptedProposals",
  rejected: "components.proposalsListModal.noRejectedProposals",
};

const getEmptyMessage = (sectionType, t) => t(EMPTY_MESSAGE_KEYS[sectionType]);

const ProposalsListSection = ({
  filteredProposals,
  sectionType,
  sortProposalsByDestacado,
  onProposalAction,
  onViewProposal,
  t,
  styles,
}) => {
  if (!filteredProposals || filteredProposals.length === 0) {
    return (
      <div className={styles.emptyMessage}>
        {getEmptyMessage(sectionType, t)}
      </div>
    );
  }

  const sortedProposals = sortProposalsByDestacado(filteredProposals);

  return sortedProposals.map((proposal, index) => {
    const user = proposal.usuario ?? null;
    const company = proposal.usuario?.empresa ?? null;
    return (
      <div key={proposal._id || index}>
        <Proposal
          proposal={proposal}
          user={user}
          company={company}
          onProposalAction={onProposalAction}
          onViewProposal={onViewProposal}
          sectionType={sectionType}
        />
      </div>
    );
  });
};

export default ProposalsListSection;
